import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { BrowserService } from '../../../shared/service/browser/browser.service';

import { HeaderSharedComponent } from './header.component';

import { TextButtonExternalSharedModule } from '../../molecules/text.button/text-button-external.module';
import { TextButtonInternalSharedModule } from '../../molecules/text.button/text-button-internal.module';
import { SelectSharedModule } from '../../molecules/select/select.module';
import { IconSharedModule } from '../../atoms/icon/icon.module';

@NgModule({
    declarations: [
        HeaderSharedComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterModule.forChild([]),
        NgbDropdownModule,
        TextButtonExternalSharedModule,
        TextButtonInternalSharedModule,
        SelectSharedModule,
        IconSharedModule
    ],
    providers: [
        BrowserService
    ],
    exports: [
        HeaderSharedComponent
    ]
})

export class HeaderSharedModule {}
